// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"451720ed","184":"304e3ad3","482":"adc09f1f","825":"60bc6606"}[chunkId] + ".chunk.css";
};